export default {
  data() {
    return {
      client: [],
      isCertA3: {},
    };
  },
  methods: {
    async getClient() {
      const { data } = await this.$http.get('application.get-client');
      this.client = data;
      this.isCertA3 = data.fiscal.emissor.isCertA3;
    },
    getStateAcronym() {
      return this.client?.addressCollection[0]?.zipCode?.city?.state?.acronym;
    },
  },
  computed: {
    isClientFromSP() {
      if (!this.client.addressCollection) return false;
      return this.getStateAcronym() === 'SP';
    },
    isClientFromCE() {
      if (!this.client.addressCollection) return false;
      return this.getStateAcronym() === 'CE';
    },
    isClientFromSC() {
      const CNPJLength = 14;
      if (!this.client.addressCollection) return false;
      return this.client?.addressCollection[0]?.zipCode?.city?.state?.acronym === 'SC' &&
             this.client.identification.length === CNPJLength;
    },
  },
};
